module.exports = __webpack_public_path__ + "img/bpifrance-logo.4ea3c89d.png";